// Los ayudantes del catálogo, aparte del componente.
//
// VIVEN AQUÍ Y NO EN `ui/Ayuda.jsx` porque un archivo que exporta un
// componente Y funciones rompe el refresco en caliente de React — lo dice
// `react-refresh/only-export-components`, y tiene razón: al editar una
// función el módulo entero se recarga y el componente pierde su estado.
import catalogo from './catalogo.json' with { type: 'json' };

const POR_ID = new Map(catalogo.notas.map((n) => [n.id, n]));

/** La nota entera, o `undefined`. */
export function notaDeAyuda(id) {
  return POR_ID.get(id);
}

/** El texto de una nota, para cuando hace falta como cadena. */
export function textoDeAyuda(id) {
  return POR_ID.get(id)?.texto ?? '';
}

/** Todas las notas de una pantalla, para las pruebas y la capa 3. */
export function ayudasDe(pantalla) {
  return catalogo.notas.filter((n) => n.ancla.pantalla === pantalla);
}
